import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

// Textarea/Input callbacks hand back either a DOM event or a bare value.
export const readValue = (eventOrValue) =>
  typeof eventOrValue === "string"
    ? eventOrValue
    : eventOrValue?.target?.value ?? "";

// Shared labelled dropdown used across the criteria field groups.
export const DropdownField = ({
  label,
  placeholder,
  options,
  selected,
  required,
  error,
  onChange,
}) => (
  <div className="ai-form-step__field">
    <span className="ai-form-step__label">
      {label}
      {required && <span className="required">*</span>}
    </span>
    <Dropdown selected={selected} onOptionSelected={onChange}>
      <DropdownButton placeholder={placeholder} required={required}>
        {selected?.name}
      </DropdownButton>
      <DropdownItems>
        {options.map((o) => (
          <DropdownItem key={o.id} value={o}>
            {o.name}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
    {error && (
      <span className="ai-form-step__error" role="alert">
        {error}
      </span>
    )}
  </div>
);
